/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MongoDataCollection {
  MaterialPriceFetches = 'material_price_fetches',
  LiveBiddingMetrics = 'live_bidding_metrics',
  LotMetrics = 'lot_metrics',
  QuoteRelayFetches = 'quote_relay_fetches'
}
